import { ViewDirection } from '../../GameKit/shared';

const defaultState = {
    score: 0,
    lives: 5,
    health: 100,
    time: 0,
    pointsGoal: -1,
    timeLimit: -1,
    pointsAtStartOfLevel: 0,
    viewDir: ViewDirection.Side,
    isPaused: false,
    isFullscreen: false,
    muted: false
};

export default function reducer(state = defaultState, action) {
    switch (action.type) {
        case 'GAMEINFO_SET_SCORE': {
            return {
                ...state,
                score: action.payload
            };
        }
        case 'GAMEINFO_SET_HEALTH': {
            return {
                ...state,
                health: action.payload
            };
        }
        case 'GAMEINFO_SET_LIVES': {
            return {
                ...state,
                lives: action.payload
            };
        }
        case 'GAMEINFO_SET_TIME': {
            return {
                ...state,
                time: action.payload
            };
        }
        case 'GAMEINFO_SET_VIEW_DIR': {
            return {
                ...state,
                viewDir: action.payload
            };
        }
        case 'GAMEINFO_SET_MUTED': {
            return {
                ...state,
                isMuted: action.payload
            };
        }
        case 'GAMEINFO_SET_PAUSED': {
            return {
                ...state,
                isPaused: action.payload
            };
        }
        case 'GAMEINFO_SET_FULLSCREEN': {
            return {
                ...state,
                isFullscreen: action.payload
            };
        }
        case 'GAMEINFO_SET_ALL_GAME_INFO': {
            return {
                ...state,
                isPaused: action.payload.isPaused,
                isFullscreen: action.payload.isFullscreen
            };
        }
        case 'GAMEINFO_SET_ALL_PLAYER_INFO': {
            return {
                ...state,
                score: action.payload.points,
                lives: action.payload.lives,
                health: action.payload.health,
                time: action.payload.time
            };
        }
        case 'GAMEINFO_SET_ALL_GOALS': {
            return {
                ...state,
                pointsGoal: action.payload.pointsGoal,
                timeLimit: action.payload.timeLimit,
                pointsAtStartOfLevel: action.payload.pointsAtStartOfLevel
            };
        }
        default: {
            return state;
        }
    }
}
